"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchStatus = void 0;
const flatbuffers = require("flatbuffers");
class MatchStatus {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsMatchStatus(bb, obj) {
        return (obj || new MatchStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsMatchStatus(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new MatchStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    description(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    periodNumber() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    state() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    abbreviation(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    static startMatchStatus(builder) {
        builder.startObject(5);
    }
    static addDescription(builder, descriptionOffset) {
        builder.addFieldOffset(0, descriptionOffset, 0);
    }
    static addPeriodNumber(builder, periodNumber) {
        builder.addFieldInt8(1, periodNumber, 0);
    }
    static addState(builder, state) {
        builder.addFieldInt8(2, state, 1);
    }
    static addAbbreviation(builder, abbreviationOffset) {
        builder.addFieldOffset(3, abbreviationOffset, 0);
    }
    static addStatus(builder, status) {
        builder.addFieldInt16(4, status, 0);
    }
    static endMatchStatus(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createMatchStatus(builder, descriptionOffset, periodNumber, state, abbreviationOffset, status) {
        MatchStatus.startMatchStatus(builder);
        MatchStatus.addDescription(builder, descriptionOffset);
        MatchStatus.addPeriodNumber(builder, periodNumber);
        MatchStatus.addState(builder, state);
        MatchStatus.addAbbreviation(builder, abbreviationOffset);
        MatchStatus.addStatus(builder, status);
        return MatchStatus.endMatchStatus(builder);
    }
}
exports.MatchStatus = MatchStatus;
